import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

interface InfoPageProps {
  eyebrow: string;
  title: string;
  description: string;
  children: ReactNode;
}

export function InfoPage({ eyebrow, title, description, children }: InfoPageProps) {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>
        <section className="bg-hero-gradient text-primary-foreground">
          <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-18 lg:px-8">
            <p className="text-xs font-bold uppercase tracking-[0.2em] opacity-80">{eyebrow}</p>
            <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
              {title}
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-7 opacity-90">{description}</p>
          </div>
        </section>
        <article className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="rounded-2xl border border-border/80 bg-card p-6 shadow-sm sm:p-10">
            <div className="prose prose-slate max-w-none dark:prose-invert prose-headings:font-display prose-headings:tracking-tight prose-a:text-primary">
              {children}
            </div>
            <div className="mt-10 border-t border-border pt-6">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline"
              >
                <ArrowLeft className="size-4" />
                Back to Picamini.online tools
              </Link>
            </div>
          </div>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
